export default __webpack_public_path__ + "static/media/text-sign-login.28a80991.svg";